import { PointGps } from './pointGps';

export interface Place {
  name: string;
  gps: PointGps;
}

/**
 * Static map place data for various regions
 */
export class MapPlaces {
  /**
   * European capital cities
   */
  public static hlavniEvropskaMesta(): Place[] {
    const csv = `
Tirana;Tiranë;Albánie;Shqipëria;AL;41.3275;19.8189
Andorra la Vella;Andorra la Vella;Andorra;Principat d'Andorra;AD;42.5063;1.5218
Vídeň;Wien;Rakousko;Österreich;AT;48.2082;16.3738
Brusel;Brussel/Bruxelles;Belgie;België/Belgique/Belgien;BE;50.8503;4.3517
Minsk;Minsk;Bělorusko;Беларусь;BY;53.9000;27.5667
Sarajevo;Sarajevo;Bosna a Hercegovina;Bosna i Hercegovina;BA;43.8563;18.4131
Sofie;Sofija;Bulharsko;България;BG;42.6977;23.3219
Záhřeb;Zagreb;Chorvatsko;Hrvatska;HR;45.8150;15.9819
Nikósie;Lefkosia/Levkoşa;Kypr;Κύπρος/Kıbrıs;CY;35.1856;33.3823
Praha;Praha;Česko;Česká republika;CZ;50.0755;14.4378
Kodaň;København;Dánsko;Danmark;DK;55.6761;12.5683
Tallinn;Tallinn;Estonsko;Eesti;EE;59.4370;24.7536
Helsinky;Helsinki;Finsko;Suomi;FI;60.1699;24.9384
Paříž;Paris;Francie;France;FR;48.8566;2.3522
Berlín;Berlin;Německo;Deutschland;DE;52.5200;13.4050
Athény;Αθήνα;Řecko;Ελλάδα;GR;37.9838;23.7275
Budapešť;Budapest;Maďarsko;Magyarország;HU;47.4979;19.0402
Dublin;Baile Átha Cliath;Irsko;Éire/Ireland;IE;53.3498;-6.2603
Řím;Roma;Itálie;Italia;IT;41.9028;12.4964
Priština;Prishtinë;Kosovo;Kosovë/Kosovo;XK;42.6629;21.1655
Riga;Rīga;Lotyšsko;Latvija;LV;56.9496;24.1052
Vaduz;Vaduz;Lichtenštejnsko;Liechtenstein;LI;47.1410;9.5209
Vilnius;Vilnius;Litva;Lietuva;LT;54.6872;25.2797
Lucemburk;Lëtzebuerg/Luxembourg;Lucembursko;Lëtzebuerg/Luxembourg;LU;49.6116;6.1319
Skopje;Скопје;Severní Makedonie;Северна Македонија;MK;41.9973;21.4280
Valletta;Valletta;Malta;Malta;MT;35.8989;14.5146
Kišiněv;Chișinău;Moldavsko;Moldova;MD;47.0105;28.8638
Monako;Monaco;Monako;Monaco;MC;43.7384;7.4246
Podgorica;Podgorica;Černá Hora;Црна Гора;ME;42.4396;19.2660
Amsterdam;Amsterdam;Nizozemsko;Nederland;NL;52.3676;4.9041
Oslo;Oslo;Norsko;Norge;NO;59.9139;10.7522
Varšava;Warszawa;Polsko;Polska;PL;52.2297;21.0122
Lisabon;Lisboa;Portugalsko;Portugal;PT;38.7223;-9.1393
Bukurešť;București;Rumunsko;România;RO;44.4268;26.1025
Moskva;Москва;Rusko;Россия;RU;55.7558;37.6173
San Marino;San Marino;San Marino;San Marino;SM;43.9356;12.4473
Bělehrad;Beograd;Srbsko;Србија;RS;44.7866;20.4489
Bratislava;Bratislava;Slovensko;Slovensko;SK;48.1484;17.1077
Lublaň;Ljubljana;Slovinsko;Slovenija;SI;46.0569;14.5058
Madrid;Madrid;Španělsko;España;ES;40.4168;-3.7038
Stockholm;Stockholm;Švédsko;Sverige;SE;59.3293;18.0686
Bern;Bern/Berne;Švýcarsko;Schweiz/Suisse/Svizzera;CH;46.9480;7.4474
Ankara;Ankara;Turecko;Türkiye;TR;39.9334;32.8597
Kyjev;Kyiv;Ukrajina;Україна;UA;50.4501;30.5234
Londýn;London;Spojené království;United Kingdom;GB;51.5074;-0.1278
Vatikán;Città del Vaticano;Vatikán;Status Civitatis Vaticanae;VA;41.9029;12.4534
`;
    return this.parseCsv(csv);
  }

  /**
   * World country capitals
   */
  public static staty(): Place[] {
    const csv = `
Kábul;Kabul;Afghánistán;افغانستان;AF;34.5553;69.2075
Tirana;Tiranë;Albánie;Shqipëria;AL;41.3275;19.8189
Alžír;Alger;Alžírsko;الجزائر;DZ;36.7538;3.0588
Andorra la Vella;Andorra la Vella;Andorra;Principat d'Andorra;AD;42.5063;1.5218
Luanda;Luanda;Angola;Angola;AO;-8.8383;13.2344
Buenos Aires;Buenos Aires;Argentina;Argentina;AR;-34.6037;-58.3816
Canberra;Canberra;Austrálie;Australia;AU;-35.2809;149.1300
Vídeň;Wien;Rakousko;Österreich;AT;48.2082;16.3738
Brusel;Brussel/Bruxelles;Belgie;België/Belgique;BE;50.8503;4.3517
Brasília;Brasília;Brazílie;Brasil;BR;-15.7939;-47.8828
Sofie;София;Bulharsko;България;BG;42.6977;23.3219
Ottawa;Ottawa;Kanada;Canada;CA;45.4215;-75.6972
Santiago;Santiago;Chile;Chile;CL;-33.4489;-70.6693
Peking;北京;Čína;中国;CN;39.9042;116.4074
Praha;Praha;Česko;Česko;CZ;50.0755;14.4378
Kodaň;København;Dánsko;Danmark;DK;55.6761;12.5683
Káhira;القاهرة;Egypt;مصر;EG;30.0444;31.2357
Tallinn;Tallinn;Estonsko;Eesti;EE;59.4370;24.7536
Helsinky;Helsinki;Finsko;Suomi;FI;60.1699;24.9384
Paříž;Paris;Francie;France;FR;48.8566;2.3522
Berlín;Berlin;Německo;Deutschland;DE;52.5200;13.4050
Athény;Αθήνα;Řecko;Ελλάδα;GR;37.9838;23.7275
Budapešť;Budapest;Maďarsko;Magyarország;HU;47.4979;19.0402
Dillí;दिल्ली;Indie;भारत;IN;28.6139;77.2090
Jakarta;Jakarta;Indonésie;Indonesia;ID;-6.2088;106.8456
Dublin;Baile Átha Cliath;Irsko;Éire;IE;53.3498;-6.2603
Jeruzalém;ירושלים/القُدس;Izrael;יִשְׂרָאֵל/إِسْرَائِيل;IL;31.7683;35.2137
Řím;Roma;Itálie;Italia;IT;41.9028;12.4964
Tokio;東京;Japonsko;日本;JP;35.6895;139.6917
Nairobi;Nairobi;Keňa;Kenya;KE;-1.2921;36.8219
Soul;서울;Jižní Korea;대한민국;KR;37.5665;126.9780
Madrid;Madrid;Španělsko;España;ES;40.4168;-3.7038
Mexico City;Ciudad de México;Mexiko;México;MX;19.4326;-99.1332
Amsterdam;Amsterdam;Nizozemsko;Nederland;NL;52.3676;4.9041
Wellington;Wellington;Nový Zéland;New Zealand;NZ;-41.2865;174.7762
Oslo;Oslo;Norsko;Norge;NO;59.9139;10.7522
Varšava;Warszawa;Polsko;Polska;PL;52.2297;21.0122
Lisabon;Lisboa;Portugalsko;Portugal;PT;38.7223;-9.1393
Moskva;Москava;Rusko;Россия;RU;55.7558;37.6173
Bělehrad;Beograd;Srbsko;Србија;RS;44.7866;20.4489
Bratislava;Bratislava;Slovensko;Slovensko;SK;48.1484;17.1077
Pretoria;Pretoria;Jihoafrická republika;South Africa;ZA;-25.7479;28.2293
Stockholm;Stockholm;Švédsko;Sverige;SE;59.3293;18.0686
Bern;Bern/Berne;Švýcarsko;Schweiz/Suisse;CH;46.9480;7.4474
Bangkok;กรุงเทพฯ;Thajsko;ไทย;TH;13.7563;100.5018
Ankara;Ankara;Turecko;Türkiye;TR;39.9334;32.8597
Kyjev;Київ;Ukrajina;Україна;UA;50.4501;30.5234
Londýn;London;Spojené království;United Kingdom;GB;51.5074;-0.1278
Washington D.C.;Washington, D.C.;Spojené státy americké;United States;US;38.9072;-77.0369
`;
    return this.parseCsv(csv, (d) => d[2]);
  }

  /**
   * Olomouc region points of interest
   */
  public static olomouckyKrajZajimavosti(): Place[] {
    const csv = `
Arboretum Bílá Lhota;49.709444;16.975
Bazilika Svatý Kopeček;49.6275;17.345
CHKO Litovelské Pomoraví;49.7;17.083333
Hora Králický Sněžník;50.208056;16.858889
Hora Praděd;50.083333;17.231111
Hrad Bouzov;49.505278;16.892778
Hrad Helfštýn;49.518333;17.628611
Hrad Šternberk;49.730556;17.301944
Jeskyně Javoříčské;49.673611;16.911389
Jeskyně Zbrašovské;49.531111;17.744722
Katakomby Šumperk;49.965;16.970556
Katedrála sv. Václava;49.597778;17.2625
Lázně Jeseník;50.229444;17.204722
Lázně Termály Velké Losiny;50.024722;17.040833
Lovecko-lesnické muzeum Úsov;49.798611;17.010556
Muzeum papírnu Velké Losiny;50.023056;17.041667
Pivovar Hanušovice;50.080556;16.936389
Přečerpávací elektrárna Dlouhé Stráně;50.095;17.183333
Přírodní rezervace Mohelnická stezka;49.7775;16.919167
Radnice Šumperk;49.965278;16.970833
Rozhledna Brána času;50.006389;17.235
Science centrum Rapotín;49.981111;17.011389
Ski areál Petrov nad Desnou;50.013056;17.058333
Sloup Nejsvětější Trojice;49.593889;17.250833
Továrna Železárny Sobotín;50.010556;17.091389
Tradiční tvarůžky;49.593611;17.250278
Vodní mlýn Vikýřovice;49.981667;17.018611
Zámek Bludov;49.940833;16.928889
Zámek Náměšť na Hané;49.602222;17.065
Zámek Štíty;49.961111;16.765
Zámek Tovačov;49.428056;17.288333
Zámek Velké Losiny;50.023889;17.04
Podzemní dílna Zlaté Hory;50.263889;17.395833
`;
    return this.parseCsvSimple(csv);
  }

  /**
   * Czech regional capital cities
   */
  public static krajskaMesta(): Place[] {
    const csv = `
Hlavní město Praha;Praha;50.0755;14.4378
Jihočeský;České Budějovice;48.9745;14.4747
Plzeňský;Plzeň;49.7384;13.3736
Karlovarský;Karlovy Vary;50.2323;12.8711
Ústecký;Ústí nad Labem;50.6607;14.0322
Liberecký;Liberec;50.7663;15.0543
Královéhradecký;Hradec Králové;50.2104;15.8252
Pardubický;Pardubice;50.0343;15.7812
Kraj Vysočina;Jihlava;49.3984;15.5874
Jihomoravský;Brno;49.1951;16.6068
Olomoucký;Olomouc;49.5938;17.2509
Zlínský;Zlín;49.2260;17.6700
Moravskoslezský;Ostrava;49.8209;18.2625
`;
    return this.parseCsv(csv, (d) => d[1]);
  }

  /**
   * Czech regions
   */
  public static kraje(): Place[] {
    const csv = `
Hlavní město Praha;Praha;50.0755;14.4378
Jihočeský;České Budějovice;48.9745;14.4747
Plzeňský;Plzeň;49.7384;13.3736
Karlovarský;Karlovy Vary;50.2323;12.8711
Ústecký;Ústí nad Labem;50.6607;14.0322
Liberecký;Liberec;50.7663;15.0543
Královéhradecký;Hradec Králové;50.2104;15.8252
Pardubický;Pardubice;50.0343;15.7812
Kraj Vysočina;Jihlava;49.3984;15.5874
Jihomoravský;Brno;49.1951;16.6068
Olomoucký;Olomouc;49.5938;17.2509
Zlínský;Zlín;49.2260;17.6700
Moravskoslezský;Ostrava;49.8209;18.2625
`;
    return this.parseCsv(csv, (d) => d[0]);
  }

  /**
   * Parse CSV with standard format (name;...;lat;lon)
   */
  private static parseCsv(csv: string, keyFn?: (parts: string[]) => string): Place[] {
    const result: Place[] = [];
    const lines = csv.split(/\r?\n/).filter((l) => l.trim().length > 0);

    for (const line of lines) {
      const parts = line.split(';');
      if (parts.length < 2) continue;

      const name = keyFn ? keyFn(parts) : parts[0];
      const lat = parseFloat(parts[parts.length - 2]);
      const lon = parseFloat(parts[parts.length - 1]);

      if (!isNaN(lat) && !isNaN(lon)) {
        result.push({ name, gps: new PointGps(lat, lon) });
      }
    }

    return result;
  }

  /**
   * Parse simple CSV format (name;lat;lon)
   */
  private static parseCsvSimple(csv: string): Place[] {
    const result: Place[] = [];
    const lines = csv.split(/\r?\n/).filter((l) => l.trim().length > 0);

    for (const line of lines) {
      const parts = line.split(';');
      if (parts.length < 3) continue;

      const name = parts[0];
      const lat = parseFloat(parts[1]);
      const lon = parseFloat(parts[2]);

      if (!isNaN(lat) && !isNaN(lon)) {
        result.push({ name, gps: new PointGps(lat, lon) });
      }
    }

    return result;
  }
}
